(ns pfo.coltype.components.common
  (:require [reagent.core :as reagent :refer [atom track!]]
            [pfo.controller :as controller :refer [subscribe]]
            [pfo.document.component :refer [is-image]]
            [pfo.util :as util]))

(defn display-when-cta-warning-applicable [collection _]
  (let [template-list (subscribe :collection-template-list)
        ref-template-map (track! #(util/associate-by :ref @template-list))
        cta-missing-warning (track!
                              (fn []
                                (boolean
                                  (when-let [ct (some-> collection :collection_type)]
                                    (and
                                      (-> ct :ref (@ref-template-map) :cta)
                                      (:cta_missing_warning ct))))))]
    (when-not @template-list
      (controller/dispatch :collection-template-list :load))
    (fn [_ component]
      [:div
       (when @cta-missing-warning
         component)])))

(def cta-missing-fields-warning-text "Alert:  Required CTA data fields are incomplete.")

(defn document-field-type [field type]
  (= type (:document_type field)))

(defn show-image-preview [field doc]
  (and (document-field-type field "image") (is-image doc)))
